import React, { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";

import App from "./App";
import { initApi } from './services/api';

const root = createRoot(document.getElementById("root"));

// Inicializar conexión al backend antes de renderizar la app.
// Si no se puede conectar, hacemos render de todos modos para no bloquear la UI,
// pero el init intenta ajustar api.defaults.baseURL para evitar errores de "status: 0".
(async function bootstrap() {
  try {
    console.log('🔌 Inicializando API antes de renderizar...');
    const res = await initApi();
    if (!res.success) {
      console.warn('⚠️ initApi no pudo detectar el backend. La app seguirá intentando con la baseURL por defecto.');
    }
  } catch (err) {
    console.warn('⚠️ Excepción durante initApi():', err?.message || err);
  } finally {
    root.render(
      <App />
    );
  }
})();